const SET_ERROR_ALERT = 'SET_ERROR_ALERT';
const CLEAR_ALL_ERROR_ALERTS = 'CLEAR_ALL_ERROR_ALERTS';

const defaultErrorTitle = 'An unexpected error has occurred';
const defaultErrorText = 'Please refresh the page and try again';

const setErrorAlert = (params = {}) => {
  const {
    errorTitle = defaultErrorTitle,
    errorText = defaultErrorText,
  } = params;


  return ({
    type: SET_ERROR_ALERT,
    payload: {
      errorTitle,
      errorText,
    },
  });
};

const clearAllErrorAlerts = () => ({
  type: CLEAR_ALL_ERROR_ALERTS,
  payload: {
  },
});


export {
  SET_ERROR_ALERT,
  CLEAR_ALL_ERROR_ALERTS,
  setErrorAlert,
  clearAllErrorAlerts,
};
